export const nav = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Work', to: '/work' },
  { label: 'Speaking', to: '/speaking' },
  { label: 'Investments', to: '/investments' },
  { label: 'Insights', to: '/insights' },
  { label: 'Press', to: '/press' },
  { label: 'Contact', to: '/contact' },
]

export const images = {
  heroPortrait:
    'https://cdn.magicpatterns.com/uploads/xjhE99NDb2yQLYnsWL8Yrc/ChatGPT_Image_Aug_4,_2026,_09_41_00_PM.png',
  aboutPortrait:
    'https://cdn.magicpatterns.com/uploads/eGCTpNKGoAVx5SpD2Y7yNA/ChatGPT_Image_Aug_4,_2026,_09_43_15_PM.png',
  portraitDesk:
    'https://cdn.magicpatterns.com/uploads/vxTYLaghq5EYhJf1qwStkF/ChatGPT_Image_Aug_4,_2026,_09_37_33_PM.png',
  headshot:
    'https://cdn.magicpatterns.com/uploads/1TswhkPhk6GtvVoUSgzZYm/Amoye_Henry.jpg',
  speakingStage:
    'https://cdn.magicpatterns.com/patterns/generated-images/82718273-8bfe-4d49-b261-77dfd0144320.jpg',
  founderMeeting:
    'https://cdn.magicpatterns.com/patterns/generated-images/76483b80-1a78-4534-9ca7-fbe2599671c4.jpg',
  ecosystem:
    'https://cdn.magicpatterns.com/patterns/generated-images/8dcb3393-e15e-45df-8135-22b35efcd92e.jpg',
  coaching:
    'https://cdn.magicpatterns.com/patterns/generated-images/e4576b30-5584-4b93-a669-12b9ad3742cb.jpg',
  light:
    'https://cdn.magicpatterns.com/patterns/generated-images/b769c5e4-db72-47aa-8054-9ece4f7d111b.jpg',
}

type Metric = {
  value: number
  prefix?: string
  suffix?: string
  label: string
}

export const metrics: Metric[] = [
  { value: 100, suffix: '+', label: 'Companies advised' },
  { value: 45, prefix: '$', suffix: 'M', label: 'Capital mobilized' },
  { value: 14, suffix: '+', label: 'Investments' },
  { value: 30, suffix: '+', label: 'Countries worked in' },
  { value: 50, suffix: '+', label: 'Speaking engagements' },
]

export const socials = [
  { label: 'LinkedIn', href: 'https://linkedin.com' },
  { label: 'X', href: 'https://x.com' },
  { label: 'Instagram', href: 'https://instagram.com' },
]
